import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ROUTER_ESTIMATE } from 'app/AppRouter';
import { getCurrentEstimateId, setCurrentEstimateId } from 'domains/estimate/Estimate.store';
import { EstimateIdParam } from 'domains/estimate/Estimate.types';
import EstimatePage from 'pages/EstimatePage/EstimatePage';

export const EstimateBase = () => {
  const globalStoreEstimateId = useSelector(getCurrentEstimateId);
  const params = useMemo(
    () => new URLSearchParams(location.search),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [globalStoreEstimateId, location.search],
  );
  const history = useHistory();
  const dispatch = useDispatch();

  const estimateIdParam = params.get(EstimateIdParam);
  const [localEstimateId, setLocalEstimateId] = useState(globalStoreEstimateId);
  const previousEstimateIdParam = useRef<string | null>(estimateIdParam);

  // set estimateId parameter properly in the URL and in store
  useEffect(() => {
    // udpate from UUID
    if (
      estimateIdParam &&
      estimateIdParam.substring(estimateIdParam.length - 36) ===
        globalStoreEstimateId.substring(globalStoreEstimateId.length - 36) &&
      globalStoreEstimateId.length > 36
    ) {
      history.replace(`${ROUTER_ESTIMATE}?${EstimateIdParam}=${globalStoreEstimateId}`);
      dispatch(setCurrentEstimateId(globalStoreEstimateId));
      return;
    }

    // globalStoreEstimateId was updated -> update local state and url
    if (globalStoreEstimateId && globalStoreEstimateId !== localEstimateId) {
      setLocalEstimateId(globalStoreEstimateId);
      history.replace(`${ROUTER_ESTIMATE}?${EstimateIdParam}=${globalStoreEstimateId}`);
      return;
    }

    // url estimateIdParam was updated -> update local state and global state
    if (estimateIdParam && estimateIdParam !== localEstimateId) {
      setLocalEstimateId(estimateIdParam);
      dispatch(setCurrentEstimateId(estimateIdParam));
      return;
    }

    if (!estimateIdParam && history.action === 'POP' && previousEstimateIdParam.current) {
      history.goBack();
      return;
    }

    if (!estimateIdParam && globalStoreEstimateId) {
      history.push(`${ROUTER_ESTIMATE}?${EstimateIdParam}=${globalStoreEstimateId}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimateIdParam, globalStoreEstimateId, dispatch, history, params]);

  useEffect(() => {
    previousEstimateIdParam.current = estimateIdParam;
  }, [estimateIdParam]);

  return <EstimatePage estimateId={localEstimateId} />;
};
